import * as React from 'react';
import {
    RoomPriceComponent,
    ProgramPriceComponent,
} from '@digitalopsdev/serviceops-reservations-components';
import type { ClusterKind, ProgramRateSnapshot, RoomRateSnapshot } from './types';
import { snapshotItemDisplayName } from './clusterUtils';
import {
    buildProgramBookingStateForDialog,
    buildReservationStateForDialog,
    buildRoomBookingStateForDialog,
    inputsFromSnapshotItem,
} from './dialogAdapter';

interface Props {
    item: RoomRateSnapshot | ProgramRateSnapshot;
    kind: ClusterKind;
    isSelected: boolean;
    onSelect: () => void;
}

export function SnapshotSourceCard({ item, kind, isSelected, onSelect }: Props) {
    const displayName = snapshotItemDisplayName(kind, item);
    const inputs = inputsFromSnapshotItem(item);
    const isRoom = kind === 'ROOM';
    const typeKey = isRoom
        ? ((item as RoomRateSnapshot).roomType ?? '')
        : (item as ProgramRateSnapshot).programType;
    const reservationState = buildReservationStateForDialog(
        isRoom ? typeKey : null,
        isRoom ? displayName : null,
        !isRoom ? typeKey : null,
        !isRoom ? displayName : null,
    );

    return (
        <div
            className={`border rounded p-2 cursor-pointer ${isSelected ? 'border-primary bg-primary bg-opacity-10' : ''}`}
            style={{ minWidth: 180 }}
            onClick={onSelect}
        >
            <div className="flex items-center justify-between mb-1">
                <span className="font-medium text-sm">{displayName}</span>
                {isSelected && <span className="badge bg-primary text-xs">✓</span>}
            </div>
            <div className="text-xs" onClick={e => e.stopPropagation()}>
                {isRoom ? (
                    <RoomPriceComponent
                        reservationState={reservationState}
                        roomBookingState={buildRoomBookingStateForDialog(typeKey, inputs)}
                    />
                ) : (
                    <ProgramPriceComponent
                        reservationState={reservationState}
                        programBookingState={buildProgramBookingStateForDialog(typeKey, inputs)}
                    />
                )}
            </div>
        </div>
    );
}
